/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TagDropdownEnrollmentForm200,
  GetApiV1TagDropdownEnrollmentForm401,
  GetApiV1TagDropdownEnrollmentForm500,
  GetApiV1TagDropdownEnrollmentFormQueryResponse,
} from "../../types/tagRegistroController/GetApiV1TagDropdownEnrollmentForm.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TagDropdownEnrollmentForm200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1TagDropdownEnrollmentForm200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TagDropdownEnrollmentForm401Schema =
  z.any() as unknown as ToZod<GetApiV1TagDropdownEnrollmentForm401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TagDropdownEnrollmentForm500Schema =
  z.any() as unknown as ToZod<GetApiV1TagDropdownEnrollmentForm500>;

export const getApiV1TagDropdownEnrollmentFormQueryResponseSchema = z.lazy(
  () => getApiV1TagDropdownEnrollmentForm200Schema,
) as unknown as ToZod<GetApiV1TagDropdownEnrollmentFormQueryResponse>;
